import { SyntheticEvent, useEffect, useRef } from 'react';
import { Navigation } from './navigation';
import { setupEventHandlers } from './event-handlers';
import { CarouselProps } from './types';
import {
  resizeContainerWidths,
  scrollToNextItem,
  scrollToPrevItem,
  setElementActive,
} from './utils';
import { CarouselContentContainer, CarouselWrapper, Content, ContentContainer } from './styles';

const Carousel = ({ content, autoWidth, width, extensionUniqueKey }: CarouselProps) => {
  const currIndexRef = useRef<number>(0);
  const contentEleRef = useRef<HTMLDivElement>(null);
  const containerEleRef = useRef<HTMLDivElement>(null);

  // This is used for mobile swiping and keeping track of starting and ending touches
  const touchRef = useRef<any>({});

  useEffect(() => {
    setupEventHandlers(contentEleRef.current, currIndexRef, autoWidth, touchRef);
  }, [autoWidth]);

  useEffect(() => {
    if (containerEleRef.current && contentEleRef.current) {
      resizeContainerWidths(
        autoWidth
          ? contentEleRef.current?.children[currIndexRef.current].getBoundingClientRect().width ??
              width
          : width,
        [containerEleRef.current, contentEleRef.current],
      );
      setElementActive(contentEleRef.current?.children[currIndexRef.current]);
    }
  }, [content, autoWidth, width]);

  return (
    content && (
      <CarouselWrapper>
        <CarouselContentContainer
          id={`carousel-container-${extensionUniqueKey}`}
          ref={containerEleRef}
        >
          <ContentContainer id={`carousel-content-${extensionUniqueKey}`} ref={contentEleRef}>
            {content.map((carouselContentItem: any, idx: number) => (
              <Content className={`item item-${idx}`} key={carouselContentItem.id || idx}>
                {carouselContentItem}
              </Content>
            ))}
          </ContentContainer>
        </CarouselContentContainer>
        <Navigation
          onPrevClick={(e: SyntheticEvent) => {
            e.preventDefault();
            const nextIndex = scrollToPrevItem(
              contentEleRef.current,
              currIndexRef.current,
              autoWidth,
            );
            currIndexRef.current = nextIndex;
          }}
          onNextClick={(e: SyntheticEvent) => {
            e.preventDefault();
            const nextIndex = scrollToNextItem(
              contentEleRef.current,
              currIndexRef.current,
              autoWidth,
            );
            (e.target as HTMLElement).focus();
            currIndexRef.current = nextIndex;
          }}
        />
      </CarouselWrapper>
    )
  );
};

export default Carousel;
